import { FC } from "react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemErrorMsg, SystemErrorTitle } from '../../constants';

const Redirect: FC = () => {
    const navigate = useNavigate();
    React.useEffect(() => {
        (async () => {
            // 認証
            try {
                const session = await fetchAuthSession();
                const accountInfoData = JSON.parse(session?.tokens?.idToken?.payload.accountInfoData?.toString() || "[]")
                // セッション情報の契約に応じて表示ページを分ける
                if (accountInfoData.length === 0) {
                    // エラー画面遷移
                    navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
                } else if (accountInfoData.length === 2) {
                    navigate("/search", {});
                } else {
                    if (accountInfoData[0].accountInfo === '0') {
                        navigate("/account", {});
                    } else {
                        navigate("/search", {});
                    }
                }

            } catch (e) {
                navigate("/Error", { state: { title: SystemErrorTitle, message: SystemErrorMsg } });
            }

        })()
    }, []);

    return <></>
}
export default Redirect;
